import React, { useEffect, useState } from 'react';
import { AudioAssistanceButton } from 'view/components/buttons/AudioAssistanceButton';
import QuestionResponse from 'models/QuestionResponse';
import { FrameProps } from './Multipart';
import useApiCall from 'contexts/ApiCall';
import CachingEngine from 'utils/CachingEngine';
import aiService from 'services/aiService';
import TeacherWritingGrader from 'view/components/teacher/assignment/grading/WritingGrader';
import { WritingType } from '../writing/WritingAssignment';

import 'view/style/student/components/newcomer/multipartAssignment.css';

const WritingFrame: React.FC<FrameProps> = ({
  question,
  response,
  teacherView = false,
  showFeedback = true,
  isEvaluation = false,
  updateResponse,
  onAddFeedback,
}) => {
  const [audioSrc, setAudioSrc] = useState<string>();
  const makeApiCall = useApiCall();
  const [questionText, setQuestionText] = useState<string[]>();

  useEffect(() => {
    setQuestionText(question.text.split('_').filter((t: any) => t !== ''));
  }, [question.text]);

  useEffect(() => {
    if (!question.check || teacherView) return;
    if (response.response && response.response !== '') {
      // update the response
      handleUpdateResponse(
        response.response,
        response.grade > 0,
        true,
        response.grade,
      );
      return;
    }
    // eslint-disable-next-line
  }, [question.check, teacherView]);

  useEffect(() => {
    if (!question.text) return;

    CachingEngine.getData(`${question.id}-audio`).then((cachedAudio) => {
      if (cachedAudio) {
        setAudioSrc(cachedAudio);
      } else {
        question.getAudioSrc().then((qSource) => {
          if (qSource) {
            setAudioSrc(qSource);
            return;
          }
          makeApiCall(aiService.convertTextToSpeech, question.text)
            .then((resp) => {
              setAudioSrc(resp);
              CachingEngine.setData(`${question.id}-audio`, resp);
            })
            .catch((error) =>
              console.error(`Failed to generate audio: ${error}`),
            );
        });
      }
    });
  }, [question.id, question.text, question.audio_src, question, makeApiCall]);

  const handleUpdateResponse = (
    responseText: string,
    correct: boolean = false,
    isAttempt: boolean = false,
    grade?: number,
    resetCheck: boolean = false,
  ) => {
    if ((response.num_attempts > 0 && response.completed) || teacherView)
      return;
    const updatedResponse = QuestionResponse.fromQuestionResponse(response);
    updatedResponse.response = responseText;
    updatedResponse.grade = grade ?? updatedResponse.grade;
    updatedResponse.num_attempts += Number(isAttempt);
    updatedResponse.completed = updatedResponse.completed || isAttempt;

    updateResponse(updatedResponse, resetCheck);
  };

  // const handleGradeResponse = (grade: number, feedback: string) => {
  //   if (!teacherView) return;

  //   const updatedResponse = QuestionResponse.fromQuestionResponse(response);
  //   updatedResponse.feedback = feedback;
  //   updatedResponse.grade = grade;

  //   updateResponse(updatedResponse);
  // };

  if (!questionText) return null;

  return teacherView || response.completed ? (
    <TeacherWritingGrader
      submissionId={response.submission}
      questionId={response.id}
      studentResponse={response.response}
      onSave={() => {}}
      onShowBook={() => {}}
      teacherView={teacherView}
      onAddFeedback={onAddFeedback}
      writingType={WritingType.FREEFORM}
    />
  ) : (
    <>
      <div className="row">
        <label className="label-large">{question.text} </label>
        <AudioAssistanceButton text={question.text} audioSrc={audioSrc} />
      </div>
      <textarea
        className=""
        style={{
          height: '100%',
          font: 'unset',
          fontFamily: 'unset',
          fontSize: 'unset',
        }}
        placeholder="Type here..."
        maxLength={5000}
        value={response.response}
        onChange={(event) => handleUpdateResponse(event.target.value)}
        readOnly={teacherView}
      />
    </>
  );
};

export default WritingFrame;
